function isUserAdmin(userDataRole:string | undefined):boolean{
    if (!userDataRole) return false;
    const role = userDataRole.toLowerCase();
    return ['super_admin', 'admin'].includes(role);
}

export default isUserAdmin;